.editAttributes {
  composes: editAttributes from '../changeBankAccount/ChangeBankAccount.css';
}
